import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

export default function TenantAnimalImportRedirect() {
  return <Redirect href={routes.myAnimals} />;
}
